import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CustomerSupportSessionState {
    isCallSelected: boolean; // true = call được chọn, false = chat được chọn
    isChatSelected: boolean; // true = chat được chọn, false = call được chọn
    inLookupMode: boolean;
    // ...other state properties
}

const initialState: CustomerSupportSessionState = {
    isCallSelected: true, // Mặc định luôn chọn call
    isChatSelected: false, // Mặc định chat không được chọn
    inLookupMode: false,
    // ...other initial state properties
};

const customerSupportSessionSlice = createSlice({
    name: 'customerSupportSession',
    initialState,
    reducers: {
        setIsCallSelected: (state, action: PayloadAction<boolean>) => {
            state.isCallSelected = action.payload;
            state.isChatSelected = !action.payload;
        },
        setIsChatSelected: (state, action: PayloadAction<boolean>) => {
            state.isChatSelected = action.payload;
            state.isCallSelected = !action.payload;
        },
        setInLookupMode: (state, action: PayloadAction<boolean>) => {
            state.inLookupMode = action.payload;
        },
        // ...other reducers
    },
});

export const { setIsCallSelected, setIsChatSelected, setInLookupMode } = customerSupportSessionSlice.actions;

export default customerSupportSessionSlice.reducer;


